import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useMemo } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";

import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";
import useSupervisorLocationFilters, {
  SupervisorLocationFilterBar,
} from "../locationFilters";

const SupervisorRejectedRequestsPage = () => {
  const pageInfo = useGetPageInfo();

  const dataList = useLoaderData("root");
  const {
    provinceFilter,
    cityFilter,
    provinces,
    filteredCities,
    setProvinceFilter,
    setCityFilter,
    matchesLocation,
  } = useSupervisorLocationFilters();
  const filteredRows = useMemo(
    () => (Array.isArray(dataList) ? dataList.filter(matchesLocation) : []),
    [dataList, matchesLocation]
  );

  let navigate = useNavigate();

  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },

    {
      id: "fullName",
      label: "نام و نام خانوادگی",
    },

    {
      id: "projectTitle",
      label: "عنوان پروژه",
    },
    {
      id: "referenceID",
      label: "شناسه درخواست",
    },

    {
      id: "stepTitle",
      label: "مرحله فعلی",
    },

    {
      id: "requestConfirmTitle",
      label: "وضعیت درخواست",
    },

    {
      id: "substationName",
      label: "ایستگاه",
    },
    {
      id: "feederName",
      label: "فیدر",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  const getRowStatus = (row) => {
    switch (row.requestConfirm) {
      case "NotChecked":
        return "gray";
      case "Canceled":
        return "danger";
      case "InProcess":
        return "primary";
      case "Completed":
        return "success";
      default:
        return "warning";
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <SupervisorLocationFilterBar
              provinceFilter={provinceFilter}
              cityFilter={cityFilter}
              provinces={provinces}
              filteredCities={filteredCities}
              onProvinceChange={setProvinceFilter}
              onCityChange={setCityFilter}
            />
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={filteredRows}
                  headCells={headCells}
                  defaultSort={{ orderBy: "updateOn", order: "desc" }}
                  pageSize={100}
                  actions={[
                    {
                      icon: useCheckPermission("edit") ? (
                        <EditIcon sx={{ width: "1rem", height: "1rem" }} />
                      ) : null,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                  ]}
                  getRowStatus={getRowStatus}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SupervisorRejectedRequestsPage;
